/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {LoginRequest, LoginResponse, SignInRequest, VerifyOtpRequest} from '../../models/auth.models';
import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from "@angular/forms";
import {first} from "rxjs";
import {ConfirmationService, PrimeNGConfig} from "primeng/api";
import {AuthService} from "../../services/auth.service";
import {BasePageComponent} from "../../base-page.component";
import {RegistryService} from "../../services/domain/registry.service";
import {RegistrationService} from "../../services/domain/registration.service";
import {ConfirmEmailViewModel} from "../../models/registrazione.models";
import {Constants} from "../../models/shared.models";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {OtpDialogComponent} from "./otp-dialog/otp-dialog.component";
import { Subscription } from 'rxjs';
import {JobPostService} from "../../services/domain/jobpost.service";
import {AnnunciFiltri, AnnunciInEvidenza, IdAnnuncioModel} from "../../models/annunci.models";


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  providers:[RegistryService,ConfirmationService, JobPostService]
})
export class SigninComponent extends BasePageComponent implements OnInit {

  public loginRequestModel : SignInRequest = new SignInRequest();
  public baseImagePath : string = "";
  public worldName : string = "";
  private registrationSubscription: Subscription | any;
  public showOtpDialog : boolean = false;
  public idAnnuncio : string = "";
  public jobPostSelected : AnnunciInEvidenza = new AnnunciInEvidenza();
  public headerDetailsDialog : string = "";
  public showDetailsDialog : boolean = false;




  constructor(private registryService: RegistryService,
              private registrationService: RegistrationService,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private _authService: AuthService,
              private jobpostService: JobPostService
  ) {
    super();
  }

  override ngOnDestroy() {
    if (this.registrationSubscription) {
      this.registrationSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.registrationSubscription = this.registrationService.registrationCompleted$
      .pipe(first())
      .subscribe((data: any) => {
        this.showSuccess("Registrazione avvenuta con successo, conferma la tua email per accedere");
      });
    let code = this.route.snapshot.paramMap.get('code');
    let userId = this.route.snapshot.paramMap.get('userId');
    this.idAnnuncio = this.route.snapshot.paramMap.get('IdAnnuncio') || "";

    if (code != null && code != "" && userId != "" && userId != null && (this.idAnnuncio == null || this.idAnnuncio == "")) {
      let model = new ConfirmEmailViewModel();
      model.Code = code;
      model.UserId = userId;
      this.asyncCall(() => this.registrationService.confirmEmail(model), response => {
        this.showSuccess("Email confermata , ora puoi accedere!");
      });
    }

    if (localStorage.getItem('remeberMe') == "true") {
      if(AuthService.AuthToken != null){
        if(AuthService.AuthToken?.length > 0){
          this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
            if(response.Item != null){
              this.authService.setAuthData(response.Item);
              if(this.idAnnuncio != "" || this.idAnnuncio != null){
                this.navigate(['/annunci', this.idAnnuncio]);
              }
              else{
                this.navigate(['/dashboard']);
              }
            }
          });
        }
      }
    } else {
      this.authService.signOut();
    }

    this.baseImagePath = this.authService.baseImagePath;
    if (this.baseImagePath == "evo") {
      this.worldName = "Evo";
    } else {
      this.worldName = "Sapiens";
    }
  }
  public async signIn(): Promise<any> {

    const requestData: LoginRequest = {
      username: '',
      password: '',
      grant_type: '',
    };

    requestData.username = this.loginRequestModel.username;
    requestData.password = this.loginRequestModel.password;


    this.showSpinner();
    const response = await this.authService.signInAsync(requestData);
    this.hideSpinner();

    if(!this.manageLoginResponse(response)) return;

    this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
      if (response.Item != null) {
        this.authService.setAuthData(response.Item);
        localStorage.setItem('remeberMe', this.loginRequestModel.remberMe.toString());
        if(this.idAnnuncio){
          this.navigate(['/annunci', this.idAnnuncio]);
        }
        else{
          this.navigate(['/dashboard']);
        }
      }
    });
  }

  private manageLoginResponse(response: LoginResponse): boolean {
    if (response.error) {
      if (response.error === "invalid_grant")
        this.showError("Credenziali errate");
      else if(response.error === Constants.ERROR_AUTH_REQUIRES_VERIFICATION)
        this.openOTPDialog();
      else
        this.showError(response.error);
      return false;
    }

    if (response.access_token) {
      let counter = 0;
      while (counter < 10) {
        if (AuthService.AuthToken == null) {
          setTimeout(function () {
          }, 500);
        } else {
          break;
        }
        counter++;
      }

      return true;
    }

    return false;
  }

  public async goToRegistration() {
    await this.navigate(['/registration']);
  }

  public resendConfirmationEmail() {
    this.navigate(['/confirm']);
  }

  public forgotPassword() {
    this.navigate(['/forgot']);
  }

  private async openOTPDialog() {
    this.showOtpDialog = true;
  }

  protected async controlOtp(otpCode: string) {
    const verifyOtp = new VerifyOtpRequest(this.loginRequestModel.username, otpCode);

    const requestData: LoginRequest = {
      username: '',
      password: '',
      grant_type: '',
    };

    requestData.username = this.loginRequestModel.username;
    requestData.password = this.loginRequestModel.password;
    requestData.grant_type = 'password';

    const response = await this._authService.verifyOtpToken(verifyOtp);
    if (response.IsSuccess) {
      const response2 = await this.authService.signInAsync(requestData);

      if (!this.manageLoginResponse(response2)) return;
      this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
        if (response.Item != null) {
          this.authService.setAuthData(response.Item);
          localStorage.setItem('remeberMe', this.loginRequestModel.remberMe.toString());
          if(this.idAnnuncio){
            this.navigate(['/annunci', this.idAnnuncio]);
          }
          else{
            this.navigate(['/dashboard']);
          }
        }
      });
    }else{
      this.showWarning(response.ErrorMessage ?? '');
    }
  }
}
